export default {
    setSubscriptions(state, subscriptions) {
        state.subscriptions = JSON.parse(JSON.stringify(subscriptions));
    }
};
